



































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import Sortable from 'sortablejs'
import apiService from '@/services/apiService'
import { UrlType } from '@/constants/urlType'
import ExtensionPromptModel from '@/models/investigation/promptModel'
import NavigationModel from '../../models/navigation/navigationModel'
import ListSectionModel from '../../models/navigation/listSectionModel'
import PromptModel from '@/models/investigation/promptModel'

@Component
export default class SectionedListAdmin extends Vue {
  // @Prop(Array) readonly sections!: Array<any>
  @Prop(Object) readonly section!: ListSectionModel<NavigationModel>
  @Prop(String) readonly sectionKey!: string
  @Prop(String) readonly sectionTitle!: string
  @Prop(String) readonly sectionItems!: string
  @Prop(Number) readonly index!: number
  @Prop(String) readonly itemKey!: string
  @Prop(String) readonly itemTitle!: string
  @Prop(Boolean) readonly editable!: boolean
  @Prop(Boolean) readonly disabled!: boolean

  private created() {
    var self = this
    this.$nextTick(function() {
      let list = document.querySelector('.' + 'prompt-list-' + this.index)
      Sortable.create(list, {
        handle: '.draghandle',
        async onEnd({
          newIndex,
          oldIndex
        }: {
          newIndex: number
          oldIndex: number
        }) {
          const itemSelected = self.section.value.splice(oldIndex, 1)[0]
          self.section.value.splice(newIndex, 0, itemSelected)
          await self.updateOrder(self.section.value)
        }
      })
    })
  }

  private async updateOrder(sectionItems: NavigationModel[]) {
    let prompts: PromptModel[] = []
    for (let i = 0; i < sectionItems.length; i++) {
      let prompt: PromptModel = new PromptModel()
      prompt.extensionPromptId = sectionItems[i].params[0]
      prompt.order = i
      prompts.push(prompt)
    }
    await apiService.post(UrlType.ExtensionPrompt + '/order', prompts)
  }
}
